import { registerEditorContribution } from 'vscode/vscode/vs/editor/browser/editorExtensions';
import { registerAction2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { InlineChatController } from 'vscode/vscode/vs/workbench/contrib/inlineChat/browser/inlineChatController';
import { InlineAccessibilityHelpContribution, StartSessionAction, CloseAction, ConfigureInlineChatAction, UnstashSessionAction, DiscardHunkAction, DiscardAction, DiscardToClipboardAction, DiscardUndoToNewFileAction, CancelSessionAction, MoveToNextHunk, MoveToPreviousHunk, ArrowOutUpAction, ArrowOutDownAction, FocusInlineChat, ViewInChatAction, ToggleDiffForChange, AcceptChanges, CopyRecordings } from 'vscode/vscode/vs/workbench/contrib/inlineChat/browser/inlineChatActions';
import { INLINE_CHAT_ID, INTERACTIVE_EDITOR_ACCESSIBILITY_HELP_ID } from 'vscode/vscode/vs/workbench/contrib/inlineChat/common/inlineChat';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import '../common/inlineChatServiceImpl.js';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { InlineChatNotebookContribution } from './inlineChatNotebook.js';
import { Extensions } from 'vscode/vscode/vs/workbench/common/contributions';
import './inlineChatSavingServiceImpl.js';
import { InlineChatAccessibleViewContribution } from './inlineChatAccessibleView.js';
import 'vscode/vscode/vs/workbench/contrib/inlineChat/browser/inlineChatSessionServiceImpl';

registerEditorContribution(INLINE_CHAT_ID, InlineChatController, 0 );
registerEditorContribution(INTERACTIVE_EDITOR_ACCESSIBILITY_HELP_ID, InlineAccessibilityHelpContribution, 3 );
registerAction2(StartSessionAction);
registerAction2(CloseAction);
registerAction2(ConfigureInlineChatAction);
registerAction2(UnstashSessionAction);
registerAction2(DiscardHunkAction);
registerAction2(DiscardAction);
registerAction2(DiscardToClipboardAction);
registerAction2(DiscardUndoToNewFileAction);
registerAction2(CancelSessionAction);
registerAction2(MoveToNextHunk);
registerAction2(MoveToPreviousHunk);
registerAction2(ArrowOutUpAction);
registerAction2(ArrowOutDownAction);
registerAction2(FocusInlineChat);
registerAction2(ViewInChatAction);
registerAction2(ToggleDiffForChange);
registerAction2(AcceptChanges);
registerAction2(CopyRecordings);
const workbenchContributionsRegistry = ( Registry.as(Extensions.Workbench));
workbenchContributionsRegistry.registerWorkbenchContribution(InlineChatNotebookContribution, 3 );
workbenchContributionsRegistry.registerWorkbenchContribution(InlineChatAccessibleViewContribution, 4 );
